export default "__VITE_ASSET__DCW_rYcK__"